module.exports = __webpack_public_path__ + "static/img/奖1.f89b35b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/奖1.png
// module id = 430
// module chunks = 2